import { FoodControlPointInstance,InstanceStatus } from "@enos-monorepo/lib";
import clsx from "clsx";

interface ReportInfoProps {
  instances?: FoodControlPointInstance[];
  isEndPeriod?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

export function ReportInfo({
  instances,
  isEndPeriod,
  disabled = false,
  onClick,
}: ReportInfoProps) {
  const styles = {
    baseCircle:
      "border-[1px] rounded-[4px] h-[18px] w-[18px] flex items-center justify-center",
    errorBg: "bg-[#8D4F61]",
    warningBg: "bg-[#FFA500]",
    defaultBg: "bg-[#296573]",
    borderGray: "border-[#DBDFE9] bg-gray-200",
    textStyles: "text-white text-3xs font-semibold",
    container: "flex justify-center",
    clickable: "cursor-pointer",
  };

  const hasError = instances?.some(
    (instance) =>
      instance.status !== InstanceStatus.completed &&
      instance.status !== InstanceStatus.completedWithErrors,
  );
  const hasWarning = instances?.some(
    (instance) => instance.status === InstanceStatus.completedWithErrors,
  );

  return (
    <div
      className={clsx(styles.container, { [styles.clickable]: !disabled })}
      onClick={() => {
        if (!disabled) onClick?.();
      }}
    >
      {instances && instances.length > 0 ? (
        <div
          className={clsx(
            styles.baseCircle,
            styles.textStyles,
            hasError
              ? styles.errorBg
              : hasWarning
                ? styles.warningBg
                : styles.defaultBg,
          )}
        >
          <span>{instances.length}</span>
        </div>
      ) : (
        <div
          className={clsx(
            styles.baseCircle,
            isEndPeriod ? styles.borderGray : "border-[#DBDFE9]",
          )}
        />
      )}
    </div>
  );
}
